import {
  type ArticleFilterDto,
  batchGetAuthorsApi,
  getArticleApi,
  getArticleFeedbackApi,
  getArticleRecommendationsApi,
  listAuthorsApi,
  putArticleFeedbackApi,
  removeArticleFeedbackApi,
  reportArticleApi,
  searchArticlesApi,
} from "../api";
import type { FeedbackType, ReportReason } from "../feedback";
import type { ArticleView } from "../models/article";

export const getArticle = (alias: string, articleId: string) => getArticleApi.invoke({ alias, articleId });

export const getArticleRecommendations = (alias: string, articleId: string) => getArticleRecommendationsApi.invoke({ alias, articleId });

export type SearchArticlesParams = {
  view: ArticleView;
  filter?: ArticleFilterDto;
  limit?: number;
  cursor?: string;
};

export const searchArticles = (params: SearchArticlesParams) => searchArticlesApi.invoke(params);

export type ListAuthorsParams = { category?: string; subcategory?: string; limit?: number; cursor?: string };

export const listAuthors = (params: ListAuthorsParams = {}) => listAuthorsApi.invoke(params);

export const batchGetAuthors = async (aliases: string[]) => (await batchGetAuthorsApi.invoke({ aliases })).authors;

/** The user's feedback on an article, or undefined when there is none. */
export const getArticleFeedback = async (alias: string, articleId: string): Promise<FeedbackType | undefined> =>
  (await getArticleFeedbackApi.invoke({ alias, articleId })).feedbackType;

export const giveArticleFeedback = (alias: string, articleId: string, feedbackType: FeedbackType) =>
  putArticleFeedbackApi.invoke({ alias, articleId, feedbackType });

export const removeArticleFeedback = (alias: string, articleId: string) => removeArticleFeedbackApi.invoke({ alias, articleId });

export const reportArticle = (alias: string, articleId: string, reason: ReportReason, explanation?: string) =>
  reportArticleApi.invoke({ alias, articleId, reason, explanation });
